/** Collapsed main sidebar width — page headers match this for visual rhythm. */
export const SIDEBAR_COLLAPSED_WIDTH = 52;

export const SIDEBAR_WIDTH = 260;

/** Top nav bar height equals collapsed sidebar width. */
export const PAGE_HEADER_HEIGHT = SIDEBAR_COLLAPSED_WIDTH;

export const PAGE_HEADER_HEIGHT_PX = `${PAGE_HEADER_HEIGHT}px`;

export const viewportBelowPageHeader = (extraPx = 0) =>
  `calc(100vh - ${PAGE_HEADER_HEIGHT + extraPx}px)`;

export const viewportBelowPageHeaderDvh = (extraPx = 0) =>
  `calc(100dvh - ${PAGE_HEADER_HEIGHT + extraPx}px)`;

export const pageHeaderSx = {
  height: PAGE_HEADER_HEIGHT_PX,
  minHeight: PAGE_HEADER_HEIGHT_PX,
  maxHeight: PAGE_HEADER_HEIGHT_PX,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
};

export const pageHeaderMinSx = {
  minHeight: PAGE_HEADER_HEIGHT_PX,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
};

export const pageTitleSx = {
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: '18px',
};
